import isNil from "lodash/isNil";

import { CURRENCY } from "../constants.ts";

const LANGUAGE_LOCAL = "en-US";

const PriceFormat = new Intl.NumberFormat(LANGUAGE_LOCAL, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const NumberFormat = new Intl.NumberFormat(LANGUAGE_LOCAL, {
  maximumFractionDigits: 2,
});

export const priceFormatter = (
  value: number | string,
  options?: { minimumFractionDigits: number; maximumFractionDigits: number }
) => {
  const Format = options
    ? new Intl.NumberFormat(LANGUAGE_LOCAL, options)
    : PriceFormat;
  return Format.format(Number(value));
};

export const toPrice = (value: number | string | null | undefined) => {
  if (isNil(value)) {
    return null;
  }
  return priceFormatter(value);
};

export const formatToNumber = (
  value: number | string | undefined | null
): number | undefined => {
  if (isNil(value)) {
    return;
  }
  return Number(value);
};

export const toLocalNumber = (
  value: number | string | undefined | null,
  options?: { maximumFractionDigits: number }
): string | undefined => {
  if (isNil(value)) {
    return;
  }

  const Format = options
    ? new Intl.NumberFormat(LANGUAGE_LOCAL, options)
    : NumberFormat;

  return Format.format(Number(value));
};

export const toPercent = (
  value: number | string | undefined | null,
  format: "percentage" | "decimal" = "decimal",
  options?: { maximumFractionDigits: number }
): string | undefined => {
  if (isNil(value)) {
    return;
  }
  let numberValue = Number(value);
  if (format === "decimal") {
    numberValue = Number(value) * 100;
  }

  return `${toLocalNumber(numberValue, options)}%`;
};

export const parseStringToNumber = (value: string) =>
  value.replace(/\$\s?|(,*)/g, "");

export const toCurrencyPrice = (
  amount: number | string | null | undefined,
  currency?: string | null | undefined
) => {
  if (isNil(amount)) {
    return null;
  }
  const curr = isNil(currency) ? CURRENCY : currency;
  return `${curr} ${toPrice(amount)}`;
};

export function calculatePercent(value: number, total: number): number {
  if (total == 0) {
    return 0;
  }
  return (value / total) * 100;
}
